@if (items?.length) {
  <div
    class="insta-learn-widget"
    [style.color]="textColor"
    [class.no-text]="!title && !description">
    <div class="insta-learn-widget__column insta-learn-widget__column--left animate__animated" [ngClass]="animation" [style.animationDelay.ms]="animationDelay">
      <h4 class="widget-title">{{ title }}</h4>
      <div class="widget-description">{{ description }}</div>
      @if (swiperComponent()?.swiper?.enabled) {
        <div class="widget-navigation">
          <button
            mat-icon-button
            class="button button--icon button--icon-extra-small"
            [disabled]="swiperComponent()?.swiper?.isBeginning"
            (click)="swiperComponent()?.swiper?.slidePrev()">
            <lib-icon icon="arrow-left"></lib-icon>
          </button>
          <button
            mat-icon-button
            class="button button--icon button--icon-extra-small"
            [disabled]="swiperComponent()?.swiper?.isEnd"
            (click)="swiperComponent()?.swiper?.slideNext()">
            <lib-icon icon="arrow-right"></lib-icon>
          </button>
        </div>
      }
    </div>
    <div class="insta-learn-widget__column insta-learn-widget__column--right">
      <lib-swiper class="widget-slider" [slides]="displayItems" [options]="swiperOptions()">
        <ng-template swiperContent let-slide="item" let-index="index">
          @if (slide) {
            <lib-insta-learn-card
              class="widget-card animate__animated"
              [ngClass]="animation"
              [style.animationDelay.ms]="animationDelay * (index + 1)"
              [item]="slide"
              theme="insta-card-small"
              (click)="openDialog.emit(index)"
              (navigate)="navigate.emit($event)">
            </lib-insta-learn-card>
          } @else {
            <div class="widget-card placeholder"></div>
          }
        </ng-template>
      </lib-swiper>
      @if (swiperComponent()?.swiper?.enabled) {
        <div class="widget-slider-navigation">
          <button
            mat-icon-button
            class="button button--icon button--icon-rounded button--icon-white-background widget-slider-prev"
            [class.d-none]="swiperComponent()?.swiper?.isBeginning"
            (click)="swiperComponent()?.swiper?.slidePrev()">
            <lib-icon icon="caret-left"></lib-icon>
          </button>
          <button
            mat-icon-button
            class="button button--icon button--icon-rounded button--icon-white-background widget-slider-next"
            [class.d-none]="swiperComponent()?.swiper?.isEnd"
            (click)="swiperComponent()?.swiper?.slideNext()">
            <lib-icon icon="caret-right"></lib-icon>
          </button>
        </div>
      }
    </div>
  </div>
}
